import React, {Component} from 'react';
import logo from "../styles/images/logo.png";
import Authenticator from './Authenticator.js';

class Toolbar extends Component {
    render() {
        return (
            <div className="toolbar navbar navbar-expand flex-column flex-md-row">
                <div className="App-logo">
                    <img alt="Fundovino logo" className="img-fluid logo"
                         src={logo}/>
                </div>
                <span className="App-title">Analytics</span>
                <span className="App-version">v 0.8.6</span>
                <Authenticator/>
            </div>
        );
    }
}

export default Toolbar;